import { useEffect, useRef, useState } from "react";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { Calculator } from "lucide-react";
import { useAppSelector } from "store/store";
import { Sheet, SheetContent } from "components/ui/sheet";
import { useLocation } from "react-router-dom";
import { ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";
import { Snackbar } from "components";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import useTimeSheetAction from "./useTimeSheetAction";
import TimesheetNavbar from "./TimesheetNavbar";
import TimesheetDepartment from "./TimesheetDepartment";
import PageReportAttendanceTimesheets from "./dialogTimesheets/PageReportAttendanceTimesheets";
import DailogSendReport from "./dialogTimesheets/DailogSendReport";
import DailogRecalculate from "./dialogTimesheets/DailogRecalculate";
import Status from "../Status";
import TimesheetCard from "./TimesheetCard";
import TimesheetTable from "./TimesheetTable";
import PublicHoliday from "./dialogTimesheets/PublicHoliday";
import { AppLog } from "services";

export default function TimeSheet() {
  //*==================Store Glogbal State===============
  const { bntSearch } = useAppSelector((state) => state.header);
  //*===============Function==================
  const dataTimesheets = useTimeSheetAction();
  const location = useLocation();
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("employeeTimesheets", selectedView);
  };
  useState<boolean>(false);
  const handleClickDepartment = ({ departmentName }: { departmentName: string }) => {
    if (selectedProductGroupCode === departmentName) return;
    setSelectedProductGroupCode(departmentName);
    selectedProductGroupCodeRef.current = departmentName;
  };
  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedProductIds([]);
    } else {
      setSelectedProductIds(allIds);
    }
  };
  const handleClickRecalculate = (title: string) => {
    if (title === "Recalculate") {
      setIsDailogRecalculate(true);
    } else {
      Snackbar({
        message: `Coming soon ${title}`,
        status: StatusMsg.warning,
      });
    }
    // }, 300); // simulate a short delay
  };
  const getShopPublicHoliday = async () => {
    try {
      const url = `${RouteApi.getShopPublicHoliday}token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: "",
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
      } else {
      }
    } catch (error) {
      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  //*===============Variable==================
  const listRef = useRef<any>(null);
  const { token } = useAppSelector((state) => state.auth);
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [isDailogTimesheets, setIsDailogTimesheets] = useState<boolean>(false);
  const [isDailogRecalculate, setIsDailogRecalculate] = useState<boolean>(false);
  const [isDailogSendReport, setIsDailogSendReport] = useState<boolean>(false);
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const [view, setView] = useState("card");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [hovered, setHovered] = useState(false);
  const [openPopoverSetting, setOpenPopoverSetting] = useState<number | null>(null);
  const [openDrawer, setOpenDrawer] = useState<number | null>(null);
  const [openDrawerPulicHoliday, setOpenDrawerPulicHoliday] = useState<number | null>(null);
  const allIds = Array.isArray(dataTimesheets?.shopEmployeeTimesheets?.data) ? dataTimesheets?.shopEmployeeTimesheets?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));

  //*===============Ueffect==================

  useEffect(() => {
    if (listRef.current && dataTimesheets?.shopEmployeeLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      dataTimesheets?.fetchMoreShopEmployeeTimesheetSearch({
        next: dataTimesheets?.shopEmployeeLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTimesheets?.shopEmployeeTimesheets?.data]);
  useEffect(() => {
    const savedView = localStorage.getItem("employeeTimesheets");
    if (savedView) {
      setView(savedView);
    }
    dataTimesheets?.getShopEmployeeTimesheetSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput, selectedProductGroupCode, dataTimesheets?.dob, bntSearch]);
  useEffect(() => {
    dataTimesheets?.fetchDepartmentTimeSheet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const recalculate = [
    {
      id: 1,
      title: "Recalculate",
      label: " Recalculate employee timesheets.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <Calculator />
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm text-gray-800">Recalculate totals based on the latest timesheet data and changes.</p>
          <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
            <li>Updates total working hours, overtime, and payroll calculations.</li>
            <li>Ensures all edits (clock-ins, breaks, shifts) are accurately reflected.</li>
            <li>Run this after importing, editing, or approving timesheets.</li>
          </ul>
        </>,
      ],
    },
  ];
  useEffect(() => {
    if (dataTimesheets?.shopEmployeeTimesheets?.data?.length) {
      const initialTimeIn = dataTimesheets?.shopEmployeeTimesheets.data.map((item: any) => item.in_time || item.starting_time || "");
      const initialBreakOut = dataTimesheets?.shopEmployeeTimesheets.data.map((item: any) => item.break_out_time || item.break_starting_time || "");
      const initialBreakIn = dataTimesheets?.shopEmployeeTimesheets.data.map((item: any) => item.break_in_time || item.break_ending_time || "");
      const initialTimeOut = dataTimesheets?.shopEmployeeTimesheets.data.map((item: any) => item.out_time || item.ending_time || "");
      dataTimesheets?.setTimeInValues(initialTimeIn);
      dataTimesheets?.setbreakOutValues(initialBreakOut);
      dataTimesheets?.setBreakInValues(initialBreakIn);
      dataTimesheets?.setTimeOutValues(initialTimeOut);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTimesheets?.shopEmployeeTimesheets]);
  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("employee_id");
    if (requestId) {
      (async () => {
        await dataTimesheets?.getShopEmployeeTimesheetDetail(requestId);
        setOpenDrawer(1);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //*===============Props==================
  const timeSheetNavbarProp = {
    selectProducts,
    selectedProductIds,
    loadingPrint: dataTimesheets?.loadingPrint,
    handlePrint: dataTimesheets?.handlePrint,
    changeView,
    setSearchTextInput,
    view,
    allIds,
    recalculate,
    handleClickRecalculate,
    setSelectProducts,
    isAllSelected,
    handleToggleSelectAll,
    setSelectedProductIds,
    setOpenPopoverSetting,
    openPopoverSetting,
    setAttendanceSetting: dataTimesheets?.setAttendanceSetting,
    attendanceSetting: dataTimesheets?.attendanceSetting,
    setDob: dataTimesheets?.setDob,
    dob: dataTimesheets?.dob,
    setOpenDrawerPulicHoliday: setOpenDrawerPulicHoliday,
  };
  const timeSheetDepartmentProp = {
    hovered,
    setHovered,
    selectedProductGroupCode,
    handleClickDepartment,
    loadingDepartmentTimeSheet: dataTimesheets?.loadingDepartmentTimeSheet,
    departmentTimeSheet: dataTimesheets?.departmentTimeSheet,
  };
  const timeSheetCardProp = {
    shopEmployeeTimesheets: dataTimesheets?.shopEmployeeTimesheets,
    fetchMoreShopEmployeeTimesheetSearch: dataTimesheets?.fetchMoreShopEmployeeTimesheetSearch,
    shopEmployeeLoading: dataTimesheets?.shopEmployeeLoading,
    listRef: listRef,
    selectProducts: selectProducts,
    setSelectedProductIds: setSelectedProductIds,
    selectedProductIds: selectedProductIds,
    setOpenDrawer: setOpenDrawer,
    setItemDetail: dataTimesheets?.setItemDetail,
    getShopEmployeeTimesheetDetail: dataTimesheets?.getShopEmployeeTimesheetDetail,
    dob: dataTimesheets?.getShopEmployeeTimesheetDetail,
    handleClickUrl: dataTimesheets?.handleClickUrl,
    openPopoverInTime: dataTimesheets?.openPopoverInTime,
    setOpenPopoverInTime: dataTimesheets?.setOpenPopoverInTime,
    attendanceSetting: dataTimesheets?.attendanceSetting,
    timeInValues: dataTimesheets?.timeInValues,
    handleChangeTimeIn: dataTimesheets?.handleChangeTimeIn,
    submitUpdateClockTime: dataTimesheets?.submitUpdateClockTime,
    loadingsubmitUpdateClockTime: dataTimesheets?.loadingsubmitUpdateClockTime,
    openPopoverOutTime: dataTimesheets?.openPopoverOutTime,
    setOpenPopoverOutTime: dataTimesheets?.setOpenPopoverOutTime,
    timeOutValues: dataTimesheets?.timeOutValues,
    handleChangeTimeOut: dataTimesheets?.handleChangeTimeOut,
  };
  const timeSheetTableProp = {
    shopEmployeeTimesheets: dataTimesheets?.shopEmployeeTimesheets,
    fetchMoreShopEmployeeTimesheetSearch: dataTimesheets?.fetchMoreShopEmployeeTimesheetSearch,
    shopEmployeeLoading: dataTimesheets?.shopEmployeeLoading,
    listRef: listRef,
    selectProducts: selectProducts,
    setSelectedProductIds: setSelectedProductIds,
    selectedProductIds: selectedProductIds,
    setOpenDrawer: setOpenDrawer,
    setItemDetail: dataTimesheets?.setItemDetail,
    getShopEmployeeTimesheetDetail: dataTimesheets?.getShopEmployeeTimesheetDetail,
    dob: dataTimesheets?.getShopEmployeeTimesheetDetail,
    handleClickUrl: dataTimesheets?.handleClickUrl,
    openPopoverInTime: dataTimesheets?.openPopoverInTime,
    setOpenPopoverInTime: dataTimesheets?.setOpenPopoverInTime,
    attendanceSetting: dataTimesheets?.attendanceSetting,
    timeInValues: dataTimesheets?.timeInValues,
    handleChangeTimeIn: dataTimesheets?.handleChangeTimeIn,
    submitUpdateClockTime: dataTimesheets?.submitUpdateClockTime,
    loadingsubmitUpdateClockTime: dataTimesheets?.loadingsubmitUpdateClockTime,
    openPopoverOutTime: dataTimesheets?.openPopoverOutTime,
    setOpenPopoverOutTime: dataTimesheets?.setOpenPopoverOutTime,
    timeOutValues: dataTimesheets?.timeOutValues,
    handleChangeTimeOut: dataTimesheets?.handleChangeTimeOut,
    shopEmployeeLoadingState: dataTimesheets?.shopEmployeeLoadingState,
    openPopoverbreakOutTime: dataTimesheets?.openPopoverbreakOutTime,
    setOpenPopoverbreakOutTime: dataTimesheets?.setOpenPopoverbreakOutTime,
    breakOutValues: dataTimesheets?.breakOutValues,
    handleChangeBreakOut: dataTimesheets?.handleChangeBreakOut,
    openPopoverbreakInTime: dataTimesheets?.openPopoverbreakInTime,
    setOpenPopoverbreakInTime: dataTimesheets?.setOpenPopoverbreakInTime,
    breakInValues: dataTimesheets?.breakInValues,
    handleChangeBreakIn: dataTimesheets?.handleChangeBreakIn,
  };

  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="text-start lg:w-auto md:w-auto w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Timesheets</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Smart Scheduling, Attendance, and Performance Tracking</p>
          </div>
          {dataTimesheets?.warning ? "" : <TimesheetNavbar {...timeSheetNavbarProp} />}
        </div>
        {dataTimesheets?.warning ? "" : <TimesheetDepartment {...timeSheetDepartmentProp} />}
      </div>
      {dataTimesheets?.warning ? (
        <Status className="h-[70vh]" errorStatus={dataTimesheets?.errorStatus} />
      ) : (
        <div className="pb-3 h-full mt-5 bg-red">
          {view === "card" ? (
            <>
              {dataTimesheets?.shopEmployeeLoadingState ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <>
                  <TimesheetCard {...timeSheetCardProp} />
                </>
              )}
            </>
          ) : (
            <>
              {dataTimesheets?.shopEmployeeTimesheets ? (
                <>
                  <TimesheetTable {...timeSheetTableProp} />
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      )}

      <Sheet
        open={openDrawer === 1}
        onOpenChange={(isOpen) => {
          setOpenDrawer(isOpen ? 1 : null);
          if (!isOpen) {
            const url = new URL(window.location.href);
            url.searchParams.delete("employee_id");
            url.searchParams.delete("working_data");
            window.history.pushState({}, "", url.toString());
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1100px] justify-between p-3 pt-[50px]">
          <PageReportAttendanceTimesheets
            employeeTimesheetDetail={dataTimesheets?.employeeTimesheetDetail}
            setEmployeeTimesheetDetail={dataTimesheets?.setEmployeeTimesheetDetail}
            shopEmployeeDetailLoadingState={dataTimesheets?.shopEmployeeDetailLoadingState}
            setShopEmployeeDetailLoadingState={dataTimesheets?.setShopEmployeeDetailLoadingState}
            setOpenDrawer={setOpenDrawer}
            attendanceSetting={dataTimesheets?.attendanceSetting}
            loadingPrint={dataTimesheets?.loadingPrint}
            onUploadSuccess={({ status }) => {
              if (status === "print") {
                dataTimesheets?.handlePrintMonthly();
              } else {
              }
            }}
            isDailogTimesheets={isDailogTimesheets}
            setIsDailogTimesheets={setIsDailogTimesheets}
            itemsDetail={dataTimesheets?.itemsDetail}
            dob={dataTimesheets?.dob}
          />
        </SheetContent>
      </Sheet>

      <BtnGoToTop />
      <DailogRecalculate
        onUploadSuccess={({ status }) => {
          if (status === "success") {
            setSelectedProductIds([]);
            setSelectProducts(false);
          } else {
          }
        }}
        isDailogRecalculate={isDailogRecalculate}
        setIsDailogRecalculate={setIsDailogRecalculate}
        selectedProductIds={selectedProductIds}
      />
      <DailogSendReport isDailogSendReport={isDailogSendReport} setIsDailogSendReport={setIsDailogSendReport} selectedProductIds={selectedProductIds} />
    </BusinessSuiteContentLayout>
  );
}
